import React, { useState } from 'react';
import { GraduationCap } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getTutorial, TutorialKey } from '@/config/pageTutorials';
import TutorialVideoModal from './TutorialVideoModal';
import { cn } from '@/lib/utils';

type PageTutorialButtonProps = {
  tutorialKey: TutorialKey;
  className?: string;
};

const PageTutorialButton: React.FC<PageTutorialButtonProps> = ({ tutorialKey, className }) => {
  const [open, setOpen] = useState(false);
  const tutorial = getTutorial(tutorialKey);

  if (!tutorial?.youtubeId) return null;

  return (
    <>
      <Button
        type="button"
        onClick={() => setOpen(true)}
        title={tutorial.title}
        aria-label={tutorial.title}
        className={cn(
          'bg-gradient-to-r from-[#1F4068] to-[#1CB3B3] text-white w-11 h-11 p-0 rounded-xl shadow-lg flex items-center justify-center transition-opacity duration-200 hover:opacity-75 active:opacity-60 active:scale-95',
          className
        )}
      >
        <GraduationCap className="w-5 h-5" />
      </Button>
      <TutorialVideoModal
        open={open}
        onOpenChange={setOpen}
        youtubeId={tutorial.youtubeId}
        title={tutorial.title}
      />
    </>
  );
};

export default PageTutorialButton;
